export const GLOBAL_ALERT_UPDATE_RECIPE_IN_EDIT_ALERT = 'GLOBAL_ALERT_UPDATE_RECIPE_IN_EDIT_ALERT';
export const GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT = 'GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT';
export const GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT_INFO = 'GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT_INFO';
export const GLOBAL_ALERT_UPDATE_RECIPE_MOVE_ALERT = 'GLOBAL_ALERT_UPDATE_RECIPE_MOVE_ALERT';
export const GLOBAL_ALERT_UPDATE_BATCH_RECIPE_MOVE_ALERT = 'GLOBAL_ALERT_UPDATE_BATCH_RECIPE_MOVE_ALERT';
export const GLOBAL_ALERT_RESET_STATE = 'GLOBAL_ALERT_RESET_STATE';

export function updateRecipeInEditAlert(open) {
  return {
    type: GLOBAL_ALERT_UPDATE_RECIPE_IN_EDIT_ALERT,
    open,
  };
}

export function updateMenuInEditAlert(open) {
  return {
    type: GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT,
    open,
  };
}

export function updateMenuInEditAlertInfo(info) {
  return {
    type: GLOBAL_ALERT_UPDATE_MENU_IN_EDIT_ALERT_INFO,
    info,
  };
}

export function updateRecipeMoveAlert(open) {
  return {
    type: GLOBAL_ALERT_UPDATE_RECIPE_MOVE_ALERT,
    open,
  };
}

export function updateBatchRecipeMoveAlert(open) {
  return {
    type: GLOBAL_ALERT_UPDATE_BATCH_RECIPE_MOVE_ALERT,
    open,
  };
}

export function resetGlobalAlert() {
  return {
    type: GLOBAL_ALERT_RESET_STATE,
  };
}
